import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { contentContext } from "../../context/contentContext";
import tmdbApi from "../../api/tmdbApi";
import SessionPopup from "../../pages/SessionPopup";
import LocationSearch from "../LocationSearch";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
//  import { withGoogleMap, GoogleMap, withScriptjs} from "react-google-maps";
import { GoogleMap, LoadScript } from "@react-google-maps/api";

let { lambda, appname } = window.app
const EditStore = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const userId = localStorage.getItem("userId");
    const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
    // // console.log('loginType',loginType,localStorage.getItem("clientid"));
    const useruniqueid = loginType === 'admin' ? localStorage.getItem("userId") : localStorage.getItem("clientid")
    // console.log('useruniqueid', useruniqueid);
    const { userData, mapsAPIkey, setMapsAPIkey } = useContext(contentContext)
    const [add, setAdd] = useState(false);
    const [message, setMessage] = useState(false);
    const [loaderEnable, setLoaderEnable] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [addressData, setAddressData] = useState({});
    // const [mapsAPIkey, setMapsAPIkey] = useState({});
    const [locationFlag, setLocationFlag] = useState(false);
    const [uploadImg, setUploadImg] = useState('');
    const [filesData, setFilesData] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);
    const [dynamicQuizId, setLocationId] = useState(null);
    const [files, setFiles] = useState([]);
    const [markers, setMarkers] = useState([]);
    const [storeFiles, setStoreFiles] = useState([])
    const [multiUploadFiles, setMultiUploadFiles] = useState([]);
    const [imageLogo, setImageLogo] = useState([]);
    const [data, setData] = useState([])
    const [editData, setEditData] = useState({
        maxVisitor: 0,
        maxPartySize: 0,
        codeExpiration: 0,
        automatedExit: 0,
        visitDuration: 15,
        maxLocationCapacity: 0,
        // basicPlan: {},
        // premiumPlan: {},
        // vipPlan: {}
    })
    const [mapaddress, setMapAddress] = useState({})
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteLoad, setDeleteLoad] = useState({});
    const [deletePopup, setDeletePopup] = useState(false);
    const [deleteLogo, setDeleteLogo] = useState({});
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("");// State for dynamic message
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [countries, setCountries] = useState('');
    const [image, setImg] = useState('')
    const [idc, setIdc] = useState("USA(+1)");
    const [IdcError, setIdcError] = useState('');
    const [preferenceStatus, setPreferenceStatus] = useState(false)
    const [spotsStatus, setSpotsStatus] = useState(false)
    const [locationStatus, setLocationStatus] = useState(true)
    const [updateFlagValue, setUpdateFlagValue] = useState(false)
    const [percentageValue, setPercentagevalue] = useState(100)

    const [tempValue, setTempValue] = useState(0);

    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
    const [ispreferenceDisabled, setIsPreferenceDisabled] = useState(true);
    const [originalData, setOriginalData] = useState({});


    // const [plans, setPlans] = useState([
    //     { id: 1, name: "Basic", price: "0", benefits: ["", "", "", ""], active: true, fixed: true },
    //     { id: 2, name: "Premium", price: "", benefits: ["", "", "", ""], active: false, showErrors: false },
    //     { id: 3, name: "VIP", price: "", benefits: ["", "", "", ""], active: false, showErrors: false },
    // ]);
    const [plans, setPlans] = useState({
        basicPlan: {
            id: 1,
            name: "Basic",
            //type: "basicPlan",
            price: "",
            benefits: ["", "", "", ""],
            active: false,
            percentage: 0,
            showErrors: false
        },
        premiumPlan: {
            id: 2,
            name: "Premium",
            // type: "premiumPlan",
            price: "",
            benefits: ["", "", "", ""],
            active: false,
            percentage: 0,
            showErrors: false
        },
        vipPlan: {
            id: 3,
            name: "VIP",
            //type: "vipPlan",
            price: "",
            benefits: ["", "", "", ""],
            active: false,
            percentage: 0,
            showErrors: false
        }
    });


    // Form state
    const [formData, setFormData] = useState({
        businessaddress: '',
        name: '',
        category: '',
        phone: '',
        logo: [],
        storeImages: [],
        idc: "USA(+1)",
        // maxVisitor: 0,
        // maxPartySize: 0,
        // codeExpiration: 0,
        // automatedExit: 0,
        // visitDuration: 0,
        // maxLocationCapacity: 0,
        // basicPlan: {},
        // premiumPlan: {},
        // vipPlan: {}


    });

    // Error state
    const [errors, setErrors] = useState({
        businessaddress: '',
        name: '',
        category: '',
        phone: ''
    });

    // Alert states
    const [showAlert, setShowAlert] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        type: '',
        message: ''
    });
    // // console.log('mapsAPIkey', mapsAPIkey);
    // let siteConfig = window?.site?.common;
    // console.log("siteConfig", siteConfig)
    // let appResourcesUrl = siteConfig?.imageCloudfront;
    useEffect(() => {
        console.log("plans state:", plans);
    }, [plans]);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    // useEffect(() => {
    // console.log("plans editDataimage:", image);
    // }, [editData]);
    useEffect(() => {
        // console.log("siteConfig", formData.idc)
        if (formData.idc) {
            setFormData((prevData) => ({ ...prevData, idc: "USA(+1)" }));
        }
    }, []);
    useEffect(() => {

        if (selectedPlace) {
            // // console.log("selectedPlace", selectedPlace)
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                ['businessaddress']: selectedPlace, // Update the changed field
            }));

        }


    }, [selectedPlace]);

    useEffect(() => {
        if (toastMessage && toastType && toast[toastType]) {
            toast[toastType](toastMessage, {
                position: "bottom-center",
                // autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage && setToastMessage("");
        }
    }, [toastMessage, toastType]);

    // useEffect(() => {
    //     if (addressData) {
    //         console.log("addressData edit", addressData)
    //         setFormData((prevData) => ({
    //             ...prevData, // Keep the other fields intact
    //             ['businessaddress']: addressData?.fullAddress, // Update the changed field
    //         }));

    //     }
    // }, [addressData]);

    useEffect(() => {
        if (window.site && window.site.common && window.site.common.google) {
            // setMapsAPIkey(window?.site?.common?.google?.mapsAPIkey)
        }

    }, [window.site]);
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }

        GetCountries();
        getCategories()
        if (id) {
            setAdd(false);
            setLocationFlag(true)
            getStore();
            // GetCompany();
            // console.log("idddddddddddddddddddddddddd", id)

        }
        else {
            setAdd(true);
            // GetCompany();
        }

    }, []);

    useEffect(() => {
        // console.log("multiUploadFiles121212", multiUploadFiles, storeFiles?.length, multiUploadFiles?.length, imageLogo?.length, filesData?.length)


        if ((multiUploadFiles?.length > 0 || imageLogo?.length > 0) && multiUploadFiles?.length == storeFiles?.length && imageLogo?.length == filesData?.length) {
            // console.log("inside", multiUploadFiles, storeFiles?.length)
            submitAPI()
        }


    }, [multiUploadFiles, storeFiles, imageLogo, filesData]);

    useEffect(() => {
        // const timer = setTimeout(() => {
        //     setPlans((prevPlans) => {
        //         let updatedPlans = prevPlans.map(plan =>
        //             tempValue[plan.id] !== undefined
        //                 ? { ...plan, percentage: tempValue[plan.id] }
        //                 : plan
        //         );
        //         return updatedPlans;
        //     });
        // }, 500); // ⏳ 500ms delay

        // return () => clearTimeout(timer);
        // console.log("percentageValue percentageValue",percentageValue)
        // let pvalue = percentageValue 
        // if(tempValue?.value){
        //     pvalue = pvalue - tempValue?.value
        // }

        console.log("ttt ", tempValue)
        // setPercentagevalue(pvalue)

    }, [tempValue]);

    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });
            setCountries(response?.result.data);

        } catch {
            console.log("error");
        }
    };

    const getStore = (e) => {
        // GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'POST',
            url: `${lambda}/getStores?appname=${appname}&userid=${useruniqueid}&storeid=${id}&token=${token}`,
            // + "&token=" + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    if (response?.data?.result) {
                        const result = response?.data?.result?.[0];
                        setFormData(result)
                        setEditData((prevData) => ({
                            ...prevData,
                            maxVisitor: result?.maxVisitor ?? prevData?.maxVisitor,
                            maxPartySize: result?.maxPartySize ?? prevData?.maxPartySize,
                            codeExpiration: result?.codeExpiration ?? prevData?.codeExpiration,
                            automatedExit: result?.automatedExit ?? prevData?.automatedExit,
                            visitDuration: result?.visitDuration ?? prevData?.visitDuration,
                            maxLocationCapacity: result?.maxLocationCapacity ?? prevData?.maxLocationCapacity,
                        }));

                        // setEditData(result?.maxVisitor,result?.maxPartySize,result?.codeExpiration,result?.automatedExit,result?.visitDuration,result?.maxLocationCapacity,)
                        if (result?.preferences) {
                            setPlans(result?.preferences)
                        }
                        // setIdc(response?.data?.result?.[0]?.idc)
                        setMapAddress({
                            businessaddress: result?.businessaddress || "",
                            latitude: result?.latitude || "",
                            longitude: result?.longitude || ""
                        })
                        let siteConfig = window?.site?.common;
                        let appResourcesUrl = siteConfig?.imageCloudfront;
                        // let logoPath = appResourcesUrl + result?.logo?.[0].filepath
                        //  console.log("image",logoPath)
                        // setUploadImg(logoPath)

                    } else {
                        // setInvalidContent(true)
                    }

                }

                // setDisableSaveBtn(false)
            });
    }
    const handleAddressChange = (addressData) => {
        setUpdateFlagValue(true)
        setFormData(prevState => ({
            ...prevState,
            businessaddress: addressData?.fullAddress || ''
        }));

    };

    // Validation function
    const validateForm = () => {
        let tempErrors = {};
        let isValid = true;

        if (!formData.businessaddress.trim()) {
            tempErrors.address = 'Address is required';
            isValid = false;
        }

        if (!formData.name.trim()) {
            tempErrors.name = 'Store name is required';
            isValid = false;
        }

        if (!formData.category) {
            tempErrors.category = 'Category is required';
            isValid = false;
        }
        if (!formData.status) {
            tempErrors.status = 'Status is required';
            isValid = false;
        }
        // if (!formData.logo || formData.logo.length === 0) {
        //     tempErrors.logo = 'Logo image is required';
        //     isValid = false;
        // }

        if (!formData.phone.trim()) {
            tempErrors.phone = 'Phone number is required';
            isValid = false;
        } else if (
            (idc === "USA(+1)" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(formData.phone)) ||
            (idc === "IND(+91)" && !/^\d{5}-\d{5}$/.test(formData.phone))
        ) {
            tempErrors.phone = 'Invalid phone number format';
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        setIdc(newCountry); // Update state
        setFormData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));
        setEditData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));
    };
    // Handle input changes
    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setUpdateFlagValue(true)
    //     let formattedValue = value;
    //     if (name === "phone") {
    //         formattedValue = value.replace(/\D/g, ""); // Remove non-numeric characters
    //         if (formattedValue.length > 10) formattedValue = formattedValue.slice(0, 10); // Limit to 10 digits

    //         if (formattedValue.length > 6) {
    //             formattedValue = `(${formattedValue.slice(0, 3)}) ${formattedValue.slice(3, 6)}-${formattedValue.slice(6)}`;
    //         } else if (formattedValue.length > 3) {
    //             formattedValue = `(${formattedValue.slice(0, 3)}) ${formattedValue.slice(3)}`;
    //         }
    //     }
    //     setEditData(prev => ({
    //         ...prev,
    //         [name]: formattedValue
    //     }));
    //     setFormData(prev => ({
    //         ...prev,
    //         [name]: formattedValue
    //     }));
    //     // Clear error when user starts typing
    //     if (errors[name]) {
    //         setErrors(prev => ({
    //             ...prev,
    //             [name]: ''
    //         }));
    //     }
    // };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdateFlagValue(true);

        let formattedValue = value;

        if (name === "phone") {
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters

            if (idc === "USA(+1)") {
                // Format: (XXX) XXX-XXXX
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (idc === "IND(+91)") {
                // Format: XXXXX-XXXXX
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
        }

        setEditData(prev => ({ ...prev, [name]: formattedValue }));
        setFormData(prev => ({ ...prev, [name]: formattedValue }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    // const preferenceChange = (e) => {
    //     console.log(e.target.value)
    //     const { name, value } = e.target;
    //     setEditData(prev => ({
    //         ...prev,
    //         [name]: value
    //     }));
    //     setFormData(prev => ({
    //         ...prev,
    //         [name]: value
    //     }));
    // };

    const preferenceChange = (e) => {
        const { name, value } = e.target;
        setUpdateFlagValue(true)
        setEditData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        let errorsList = { ...errors }
        errorsList[`${name}`] = ""
        setErrors(errorsList)

    };
    // const preferenceChange = (e) => {
    //     let { name, value, type } = e.target;

    //     setUpdateFlagValue(true);

    //     // Convert value to a number
    //     let numericValue = type === "number" || type === "range" ? Number(value) : value;

    //     // Ensure numeric value is not NaN
    //     if (isNaN(numericValue) || value === "") {
    //         numericValue = 0;
    //     }

    //     // Enforce min values where needed
    //     const minValues = {
    //         visitDuration: 15,
    //         maxVisitor: 0,
    //         automatedExit: 0,
    //         codeExpiration: 0,
    //         maxPartySize: 0,
    //         maxLocationCapacity: 0
    //     };

    //     if (minValues[name] !== undefined) {
    //         numericValue = Math.max(numericValue, minValues[name]);
    //     }

    //     // Update state
    //     setEditData((prev) => ({
    //         ...prev,
    //         [name]: numericValue
    //     }));

    //     setFormData((prev) => ({
    //         ...prev,
    //         [name]: numericValue
    //     }));
    // };




    // Handle logo upload
    // const handleLogoUpload = (e) => {
    //     const file = e.target.files[0];
    //     // console.log("file",file)
    //     if (file) {
    //         // Add file size and type validation here
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setFormData(prev => ({
    //                 ...prev,
    //                 logo: [reader.result]
    //             }));
    //             // console.log("file121212",formData)
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };

    const handleFileChange = (event) => {
        setUpdateFlagValue(true)
        const selectedFile = event.target.files[0];
        // const selectedFilesSize = selectedFile.size; //for single file
        const selectedFiles = Array.from(event.target.files);  //for multiple files
        // const selectedFilesSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);  //for multiple files
        // console.log("selectedFile ", selectedFile)
        // console.log("selectedFiles ", selectedFiles)
        const allowedFileTypes = ["image/jpeg", "image/png", "image/heic"];
        let fileSize = 1048612 * 5 // 5MB
        if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
            setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
            setToastType("warning")
            event.target.value = null;
            return;
        }
        else if (selectedFile?.size < fileSize) {
            // if (selectedFile) {
            //     // Create a preview URL for the image
            //     const previewUrl = URL.createObjectURL(selectedFile);
            //     setFormData(previewUrl); // Store the URL in state
            // }
            if (selectedFile) {
                const previewUrl = URL.createObjectURL(selectedFile);
                setFormData(prev => ({
                    ...prev,
                    logo: [{ filepath: previewUrl }]
                }));

                // Clear logo error when a file is selected
                setErrors(prev => ({ ...prev, logo: "" }));
            }
            setFilesData(selectedFiles)

        } else {
            setToastMessage("File size should not exceed 5MB"); // Set the error message
            setToastType("warning")
            event.target.value = null;

        }


        // if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
        //     setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
        //     setToastType("warning")
        //     event.target.value = null;
        //     return;
        // }else if (selectedFile.size < fileSize) {
        //         const previewUrl = URL.createObjectURL(selectedFile);
        //         console.log("prevvvvvvvvvvvvvvvvvvvvvv",previewUrl)
        //         setEditUser(prev => ({
        //             ...prev,
        //             logo: previewUrl 
        //         }));
        //         setFilesData([selectedFile]); // Store file data

        //     } else {
        //         setToastMessage("File size should not exceed 5MB"); // Set the error message
        //         setToastType("warning")
        //         event.target.value = null;

        //     }


        // setFiles([...files, ...selectedFiles]); //for multiple files




    };

    // Handle store image upload
    const handleStoreImageUpload = (e) => {
        setUpdateFlagValue(true)
        const selectedFiles = Array.from(e.target.files); // Convert FileList to an array

        console.log("selectedFiles: ", selectedFiles);

        if (selectedFiles.length === 0) return; // Exit if no files are selected

        let maxFileSize = 1048612 * 5; // 5MB

        // Filter out files that exceed the size limit
        const validFiles = selectedFiles.filter(file => file.size < maxFileSize);
        // console.log("Image URLs validFiles: ", validFiles);
        if (validFiles.length === 0) {
            setFileSizeError(true);
            return;
        }
        console.log("Image URLs: ", validFiles);
        // Create preview URLs for valid files
        validFiles.map(file => {
            file["image"] = URL.createObjectURL(file)
            setStoreFiles(prevItems => [...prevItems, file]);
        });

        console.log("ImagevalidFiles URLs: ", validFiles);
        //  validFiles[0]["image"] = imageUrls[0]
        // Ensure `storeImages` is an array before spreading it
        // setFormData(prev => ({
        //     ...prev,
        //     storeImages: Array.isArray(prev.storeImages) ? [...prev.storeImages, ...imageUrls] : [...imageUrls]
        // }));

        // setStoreFiles(validFiles);

        // setTimeout(() => {
        //     uploadStoreImages(validFiles)
        // }, 1000);

    };

    const uploadStoreImages = async () => {
        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)
        //    // console.log("filesData: ", validFiles);
        //   let filesData = validFiles;
        if (storeFiles && storeFiles?.length > 0) {

            const uploadPromises = Array.from(storeFiles).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    // console.log("data", data)
                    const newFile = {
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }
                    // const updatedFiles = [...multiUploadFiles, ...newFile];
                    console.log("store image newFilenewFile", newFile)


                    axios.post(
                        `${lambda}/uploadURL?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const url = uploadUrlResponse.data.result;

                            return axios.put(url, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    setMultiUploadFiles(prevItems => [...prevItems, newFile]);

                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);
                return true
            } catch (error) {
                console.error('Error during file upload:', error);
                return false
            }
        } else {
            return true
        }

    }

    const handleUploadSubmit = async () => {
        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)
        if (filesData && filesData?.length > 0) {

            const uploadPromises = Array.from(filesData).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    // // console.log("data", data)
                    const newFile = [{
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }]
                    // const updatedFiles = [...imageLogo, ...newFile];
                    // setImageLogo(updatedFiles)

                    const uploadPromise = axios.post(
                        `${lambda}/uploadURL?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const url = uploadUrlResponse.data.result;

                            return axios.put(url, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    const updatedFiles = [...imageLogo, ...newFile];
                                    setImageLogo(updatedFiles)

                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);
                return true
            } catch (error) {
                console.error('Error during file upload:', error);
                return false
            }
        } else {
            return true
        }

    }

    const submitAPI = async () => {
        //  // console.log("files ", filesData)



        // // console.log("imageLogo", imageLogo)
        let logoImage = imageLogo;
        let geoData = {}
        if (Object.keys(addressData)?.length > 0) {
            geoData = {
                latitude: addressData?.geolocation?.location?.lat?.(),
                longitude: addressData?.geolocation?.location?.lng?.(),
                url: addressData?.url,
                state: addressData?.state,
                city: addressData?.city,
                county: addressData?.county,
                businessaddress: addressData?.fullAddress
            }
        }

        // const latitude = addressData?.geolocation?.location?.lat?.();
        // const longitude = addressData?.geolocation?.location?.lng?.();
        // const url = addressData?.url;
        // const state = addressData?.state;
        // const city = addressData?.city;
        // const county = addressData?.county;

        // if (latitude && longitude) {
        //     // console.log("Latitude:", latitude);
        //     // console.log("Longitude:", longitude);
        // } else {
        //     // console.log("Geolocation data is missing!");
        // }


        try {
            //  console.log("Submitting data:", updatedEditData);  // Debugging output
            console.log("form edit", formData)
            console.log("editData", editData)
            console.log(geoData, 'geoData');
            // let mergedData = { ...updatedEditData, ...editData };
            // console.log(mergedData, 'mergedData');
            // // console.log("multiUploadFiles", multiUploadFiles)
            // // console.log("logoImage", logoImage)
            setIsLoading(true);
            if (id) {
                //console.log("logoImageedit logoImage", logoImage)
                console.log("logoImageedit multiUploadFiles", multiUploadFiles)
                let locationImages = formData?.storeImages
                const updatedStoreImages = [...locationImages, multiUploadFiles];
                console.log("updatedStoreImages", updatedStoreImages);
                let cleanedData = updatedStoreImages.flat().filter(item => !(typeof item === "string" && item.startsWith("blob:")));
                console.log("cleanedData", cleanedData);
                let payload = editData
                if (logoImage && logoImage?.length > 0) {
                    payload["logo"] = logoImage
                }

                if (cleanedData && cleanedData?.length > 0) {
                    payload["storeImages"] = cleanedData
                }

                let mergedData = { ...editData, ...geoData };
                console.log(mergedData, 'mergedData');


                const response = await axios.post(
                    `${lambda}/updateStore?appname=${appname}&userid=${useruniqueid}&storeid=${id}`,
                    mergedData,
                );

                if (response.data.result) {
                    setMultiUploadFiles([])
                    setImageLogo([])
                    setStoreFiles([])
                    getStore()
                    setMessage(true);
                    setIsLoading(false);
                    setAdd(false)
                    setLoaderEnable(false)
                    setLocationFlag(true)
                    setToastMessage("Location Updated Successfully")
                    setToastType("success")
                    setPreferenceStatus(true);
                    setLocationStatus(false);
                }
            } else {
                console.log(logoImage, 'logoImage');
                if (logoImage && logoImage?.length > 0) {
                    formData["logo"] = logoImage
                }
                console.log(useruniqueid, 'useruniqueid');
                console.log(userData, 'userData');
                formData["createdBy"] = {
                    name: userData?.name, // Replace with actual username
                    userid: useruniqueid
                }
                console.log(formData, 'formData222');
                console.log(multiUploadFiles, 'multiUploadFiles');
                if (multiUploadFiles && multiUploadFiles?.length > 0) {
                    formData['storeImages'] = multiUploadFiles
                }
                formData['status'] = "INACTIVE"
                console.log(formData, 'formDatddda');
                let mergedData = { ...formData, ...geoData };
                console.log(mergedData, 'mergedData');
                // formData['url'] = url
                // formData['state'] = state
                // formData['city'] = city
                // formData['county'] = county
                // formData['latitude'] = latitude
                // formData['longitude'] = longitude

                console.log(geoData, 'geoData');
                console.log(mergedData, 'addpayload');
                console.log('ueeee ', `${lambda}/addStore?appname=${appname}&userid=${useruniqueid}`)
                const response = await axios.put(
                    `${lambda}/addStore?appname=${appname}&userid=${useruniqueid}`,
                    mergedData,
                );
                console.log(response, 'response');
                if (response.data.result) {
                    // response.data.result === "Store Created Successfully"
                    id = response?.data?.result;
                    // console.log("id", id)
                    navigate("/editstore/" + id);
                    getStore()
                    setMessage(true);
                    setIsLoading(false);
                    setAdd(false)
                    setLoaderEnable(false)
                    setLocationFlag(true)
                    setMultiUploadFiles([])
                    setImageLogo([])
                    setStoreFiles([])
                    setToastMessage("Location Created Successfully")
                    setToastType("success")
                    setPreferenceStatus(true);
                    setLocationStatus(false);
                }
            }
        } catch (error) {
            setAlertConfig({
                title: 'Error',
                type: 'error',
                message: error.response?.data?.message || 'Something went wrong'
            });
            setShowAlert(true);
        }
    };
    const getCategories = async () => {
        setIsLoading(true)
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(`${lambda}/getCategories?appname=${appname}&token=${token}&pagename=store`);

            if (response?.data?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true);
                setIsLoading(false)
            } else {

                setData(response?.data?.result);
                setIsLoading(false)
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };
    // Handle form submission
    const handleSubmit = async () => {
        //  // console.log("files ", filesData)

        setLoaderEnable(true)
        if (!validateForm()) {
            // setAlertConfig({
            //     title: 'Error',
            //     type: 'error',
            //     message: 'Please fix the form errors before submitting.'
            // });
            // setShowAlert(true);
            setLoaderEnable(false)
            return;
        }


        if (filesData?.length > 0) {
            await handleUploadSubmit()
            // console.log('logoSubmit 0', logoSubmit)
        }

        if (storeFiles?.length > 0) {
            await uploadStoreImages()
            // console.log('storeImagesSubmit 0', storeImagesSubmit)
        }
        if (filesData?.length == 0 && storeFiles?.length == 0) {
            submitAPI()
        }
    };
    // Handle back button
    const handleBack = () => {
        navigate("/storemanagement");
    };
    const handleClose = () => {
        setShowDeleteAlert(false)
        setDeletePopup(false)
    };

    const handleRemove = () => {
        console.log("deleteItem123123", formData)
        setUpdateFlagValue(true)
        let logo = formData && formData?.logo && formData?.logo?.[0] && formData?.logo?.[0]?.fileid
        if (logo) {
            setShowDeleteAlert(true)
        } else {
            setFormData(prev => ({
                ...prev,
                logo: [] // Clear the logo array
            }));
        }



    }

    const deleteclick = (item, index) => {
        console.log("item", item)
        setUpdateFlagValue(true)
        let storeimage = item?.fileid;
        if (storeimage) {
            setDeleteLoad(storeimage)
            setDeletePopup(true)
            // setToastMessage("Client Details Updated Successfully")
            // setToastType("success")
        } else {
            setStoreFiles(prevImages => prevImages.filter((_, i) => i !== index));

        }

    }

    const deletePopupClick = async () => {
        // setDeleteLoad(true)

        setDeletePopup(false)
        const token = localStorage.getItem('token');
        console.log("deleteItem", formData)
        let storeid = formData?.storeid
        let images = formData?.storeImages;
        console.log("images", images)
        let sameFile = deleteLoad;
        console.log("sameFile", sameFile)
        let filteredImage = images.filter(img => img.fileid !== sameFile);
        console.log("uniqueImages", filteredImage);

        setEditData(prev => ({
            ...prev,
            "storeImages": filteredImage
        }));
        setFormData(prev => ({
            ...prev,
            "storeImages": filteredImage // Clear the logo array
        }));

    }
    const handleDeleteClick = async () => {
        // setDeleteLoad(true)
        setShowDeleteAlert(false)
        //const token = localStorage.getItem('token');
        //console.log("deleteItem", formData)
        //let storeid = formData?.storeid

        setEditData(prev => ({
            ...prev,
            "logo": []
        }));

        setFormData(prev => ({
            ...prev,
            logo: [] // Clear the logo array
        }));

        // try {
        //     const payload = {
        //         "logo": []
        //     };
        //     const response = await axios.post(
        //         `${lambda}/updateStore?appname=${appname}&userid=${useruniqueid}&storeid=${storeid}`, payload

        //     );

        //     if (response.data.result) {
        //         getStore()
        //     }
        // } catch (error) {
        //     console.error('Error deleting image:', error);
        // }
    }

    // console.log("addressDataaddressData", formData)
    // console.log(editData, 'editData');

    const spotClick = () => {
        navigate("/spotsmanage/" + id);
        // navigate("/spotsmanage");
    }
    const handleTabSwitch = (tab) => {
        if (tab === "preferences") {
            if (!validateForm()) {
                setToastMessage("Please add location details before proceeding.");
                setToastType("error");
                setPreferenceStatus(false);
                return;
            } else {
                setPreferenceStatus(true);
                setLocationStatus(false);
                setSpotsStatus(false)
            }

        }
        else if (tab === "spots") {
            if (!validateForm()) {
                setToastMessage("Please add location details and preferences before proceeding.");
                setToastType("error");
                setSpotsStatus(false);
                return;
            } else {
                setPreferenceStatus(false);
                setLocationStatus(false);
                setSpotsStatus(true)
            }
        }
        else if (tab === "location") {
            setLocationStatus(true);
            setPreferenceStatus(false);
            setSpotsStatus(false)
        }
    };

    const toggleActive = (id, key) => {
        let errorsList = { ...errors };
        errorsList[`${key}_price`] = "";
        errorsList[`${key}_benefit_0`] = "";

        setUpdateFlagValue(true);

        console.log("key ", key, id)


        if (tempValue == 0) {
            setPlans((prevPlans) => {
                // Clone previous state
                let updatedPlans = { ...prevPlans };

                // Toggle active state
                updatedPlans[key] = {
                    ...updatedPlans[key],
                    active: !updatedPlans[key].active,
                };
                // Get all active plans
                let activePlans = Object.keys(updatedPlans).filter(
                    (planKey) => updatedPlans[planKey].active
                );
                // Calculate percentage distribution
                let newPercentage = activePlans.length > 0 ? Math.floor(100 / activePlans.length) : 0;
                // Update active plans' percentage
                activePlans.forEach((planKey) => {
                    updatedPlans[planKey] = {
                        ...updatedPlans[planKey],
                        percentage: newPercentage,
                    };
                });
                // Set inactive plans' percentage to 0
                Object.keys(updatedPlans).forEach((planKey) => {
                    if (!updatedPlans[planKey].active) {
                        updatedPlans[planKey] = {
                            ...updatedPlans[planKey],
                            percentage: 0,
                        };
                    }
                });
                return { ...updatedPlans }; // Ensure a new state object is returned
            });
        } else {
            let pValue = percentageValue - tempValue
            setPlans((prevPlans) => {
                let updatedPlans = { ...prevPlans };

                // Update the edited plan's percentage
                updatedPlans[key] = {
                    ...updatedPlans[key],
                    percentage: pValue,
                    active: !updatedPlans[key].active,
                };

                // Set inactive plans' percentage to 0
                Object.keys(updatedPlans).forEach((planKey) => {
                    if (!updatedPlans[planKey].active) {
                        updatedPlans[planKey] = {
                            ...updatedPlans[planKey],
                            percentage: 0,
                        };
                    }
                });

                return updatedPlans;
            });
            setTempValue(pValue)
            setPercentagevalue(pValue)
        }


        setErrors(errorsList);

    };

    // const toggleActive = (id, key) => {
    //     let errorsList = { ...errors };
    //     errorsList[`${key}_price`] = "";
    //     errorsList[`${key}_benefit_0`] = "";

    //     setUpdateFlagValue(true);

    //     setPlans((prevPlans) => {
    //         if (!Array.isArray(prevPlans)) {
    //             console.error("Error: prevPlans is not an array", prevPlans);

    //             // Convert Object to Array (if needed)
    //             prevPlans = Object.values(prevPlans);
    //         }

    //         let updatedPlans = [...prevPlans];

    //         // Find the toggled plan
    //         let toggledPlan = updatedPlans.find(plan => plan.id === id);
    //         if (!toggledPlan) return prevPlans;

    //         // Toggle the active state of the selected plan
    //         toggledPlan.active = !toggledPlan.active;

    //         // Get all active plans
    //         let activePlans = updatedPlans.filter(plan => plan.active);
    //         let activeCount = activePlans.length;

    //         if (activeCount === 0) {
    //             // If no active plans, reset everything to 0
    //             updatedPlans = updatedPlans.map(plan => ({ ...plan, percentage: 0 }));
    //         } else {
    //             // Get total assigned percentage of active plans
    //             let totalAssignedPercentage = activePlans.reduce((sum, plan) => sum + plan.percentage, 0);
    //             let remainingPercentage = 100 - totalAssignedPercentage;

    //             if (toggledPlan.active) {
    //                 // If activating a new plan, distribute remaining percentage fairly
    //                 let newPercentage = Math.floor(remainingPercentage / activeCount);

    //                 updatedPlans = updatedPlans.map(plan => {
    //                     if (plan.active) {
    //                         return { ...plan, percentage: plan.id === id ? newPercentage : plan.percentage };
    //                     }
    //                     return { ...plan, percentage: 0 };
    //                 });
    //             } else {
    //                 // If deactivating a plan, redistribute its percentage among remaining active plans
    //                 let redistributionAmount = toggledPlan.percentage;
    //                 let newShare = activeCount > 0 ? Math.floor(redistributionAmount / activeCount) : 0;

    //                 updatedPlans = updatedPlans.map(plan => {
    //                     if (plan.active) {
    //                         return { ...plan, percentage: plan.percentage + newShare };
    //                     }
    //                     return { ...plan, percentage: 0 };
    //                 });
    //             }
    //         }

    //         return updatedPlans;
    //     });

    //     setErrors(errorsList);
    // };




    // const handlePercentageChange = (e, type) => {
    //     let value = Number(e.target.value);
    //     if (isNaN(value) || value < 0) return;

    //     setPlans((prevPlans) => {
    //         if (!prevPlans || typeof prevPlans !== "object") {
    //             console.error("prevPlans is not an object", prevPlans);
    //             return prevPlans; // Return the existing state if it's incorrect
    //         }

    //         let plansArray = Object.values(prevPlans); // Convert object to array
    //         let updatedPlans = plansArray.map((plan) =>
    //             plan.type === type ? { ...plan, percentage: value } : plan
    //         );

    //         console.log("Updated Plans", updatedPlans);
    //         return updatedPlans;
    //     });

    // };










    // const toggleActive = (id, key) => {
    //     let errorsList = { ...errors };
    //     errorsList[`${key}_price`] = "";
    //     errorsList[`${key}_benefit_0`] = "";

    //     setUpdateFlagValue(true);

    //     setPlans((prevPlans) => {
    //         const updatedPlans = Object.keys(prevPlans).reduce((acc, planKey) => {
    //             const plan = prevPlans[planKey];

    //             acc[planKey] = plan?.id === id
    //                 ? {
    //                     ...plan,
    //                     active: !prevPlans[key].active,
    //                     showErrors: false,
    //                     ...(prevPlans[key].active
    //                         ? { price: "", benefits: plan.benefits.map(() => "") } // Clears values but keeps input fields
    //                         : {}),
    //                 }
    //                 : plan;

    //             return acc;
    //         }, {});

    //         return updatedPlans;
    //     });

    //     setErrors(errorsList);
    // };

    const handlePercentageChange = (e, id, key) => {
        let value = e.target.value;
        //if (isNaN(value) || value < 0 || value > 100) return; // Ensure valid range (0-100)

        let plansList = { ...plans }

        console.log("plansLsit", plansList, value)
        //   plansList?[key]?.percentage : value
        // console.log("plansLsitxxx", plansList)
        //  setPlans(plansList)

        setPlans((prevPlans) => {
            let updatedPlans = { ...prevPlans };

            // Update the edited plan's percentage
            updatedPlans[key] = {
                ...updatedPlans[key],
                percentage: value != "" ? Number(value) : "",
            };

            return updatedPlans;
        });


        setTempValue(value);

    };








    const handlePlansChange = (id, field, value, index = null) => {
        setUpdateFlagValue(true);
        console.log("field ", field, value, index, id);

        if (field === "price" && isNaN(value) || Number(value) < 0) {
            return; // Ignore non-numeric input
        }

        setPlans((prevPlans) => {
            const updatedPlans = Object.keys(prevPlans).reduce((acc, key) => {
                const plan = prevPlans[key];

                if (plan?.id === id) {
                    if (field !== "price") {
                        // ✅ Update benefits array properly
                        const updatedBenefits = [...plan?.benefits];
                        updatedBenefits[index] = value;
                        acc[key] = { ...plan, benefits: updatedBenefits };
                    } else {
                        // ✅ Update price field
                        acc[key] = { ...plan, [field]: value };
                    }
                } else {
                    acc[key] = plan;
                }
                return acc;
            }, {});

            console.log("Updated Plans:", updatedPlans);
            return updatedPlans;
        });
    };

    const capitalizeFirstLetter = (string) => {
        let value = string.replace(/([A-Z])/g, " $1")
        let field = value.charAt(0).toUpperCase() + value.slice(1)
        return field
    }

    // const validatePreferences = () => {
    //     let newErrors = {};
    //     //let hasErrors = false;

    //     // ✅ Validate Main Preferences
    //     const requiredFields = [
    //         "maxVisitor",
    //         "visitDuration",
    //         "codeExpiration",
    //         "maxPartySize",
    //         "automatedExit",
    //         "maxLocationCapacity",
    //     ];

    //     requiredFields.forEach((field) => {
    //         if (!editData[field]) {
    //             newErrors[field] = `${capitalizeFirstLetter(field)} is required`;
    //             // hasErrors = true;
    //         } else {
    //             delete errors[field];
    //         }
    //     });


    //     // ✅ Validate Basic Plan (Always Required)
    //     const basicPlan = plans?.basicPlan;
    //     if (basicPlan?.active && !basicPlan?.benefits?.[0]?.trim()) {
    //         newErrors["basicPlan_benefit_0"] = "At least one benefit is required for Basic Plan";
    //     } else {
    //         delete newErrors["basicPlan_benefit_0"];
    //     }

    //     // ✅ Validate Other Plans ONLY IF Active
    //     ["premiumPlan", "vipPlan"].forEach((planKey) => {
    //         const plan = plans[planKey];
    //         if (!plan?.active) return; // Skip validation if not active

    //         if (!plan?.price?.trim()) {
    //             newErrors[`${planKey}_price`] = "Price is required";
    //         } else if (isNaN(plan?.price) || Number(plan?.price) <= 0) {
    //             newErrors[`${planKey}_price`] = "Enter a valid price";
    //         } else {
    //             delete newErrors[`${planKey}_price`];
    //         }

    //         if (!plan?.benefits?.[0]?.trim()) {
    //             newErrors[`${planKey}_benefit_0`] = "At least one benefit is required";
    //         } else {
    //             delete newErrors[`${planKey}_benefit_0`];
    //         }
    //     });

    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0; //
    // };

    const handleSave = async (e) => {
        e.preventDefault();
        setLoaderEnable(true);
        console.log("Updated Plans Before Validation:", plans);
        let total = Object.values(plans)
            .filter(plan => plan.active)
            .reduce((sum, plan) => sum + plan.percentage, 0);

        console.log("Total Percentage:", total);
        // return total;
        if (total > 100) {
            setErrors(prevErrors => ({
                ...prevErrors,
                percentage: "Total percentage cannot exceed 100%",
            }));
            setLoaderEnable(false);
            return;
        }
        if (!validatePreferences()) {
            console.log("Validation failed. Aborting API call.");
            setLoaderEnable(false);
            return;
        }

        console.log("Validation Passed. Proceeding with API call...");

        try {
            // ✅ Filter valid plans:
            // - Always include Basic Plan
            // - Include Premium/VIP **only if active**
            // let filteredPlans = Object.keys(plans).reduce((acc, key) => {
            //     const plan = plans[key];

            //     if (
            //         plan?.name === "Basic" || // Always include Basic Plan
            //         (plan?.active && plan?.price?.trim() && plan?.benefits?.some((b) => b.trim() !== ""))
            //     ) {
            //         acc[key] = {
            //             price: plan.price,
            //             benefits: plan.benefits.filter((b) => b.trim() !== ""),
            //             active: plan.active,
            //         };
            //     }
            //     return acc;
            // }, {});
            setLoaderEnable(true);
            let data = {};
            data["preferences"] = plans

            console.log("Data to be sent:", data);

            if (id) {
                let mergedData = { ...editData, ...data };
                console.log("Merged Data for API:", mergedData);

                const response = await axios.post(
                    `${lambda}/updateStore?appname=${appname}&userid=${useruniqueid}&storeid=${id}`,
                    mergedData
                );

                console.log("API Response:", response);

                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                } else if (response?.data?.result) {
                    setMultiUploadFiles([]);
                    setImageLogo([]);
                    setStoreFiles([]);
                    getStore();
                    setMessage(true);
                    setIsLoading(false);
                    setAdd(false);
                    setLoaderEnable(false);
                    setLocationFlag(true);
                    setToastMessage("Preferences Updated Successfully");
                    setToastType("success");
                    setPreferenceStatus(false);
                    setLocationStatus(false);
                    setSpotsStatus(true)
                }
            }
        } catch (error) {
            console.error("Error updating store:", error);
            setAlertConfig({
                title: "Error",
                type: "error",
                message: error.response?.data?.message || "Something went wrong",
            });
            setShowAlert(true);
        }

        //setLoaderEnable(false);
    };

    const validatePreferences = () => {
        let newErrors = {};

        // ✅ Validate Main Preferences
        const requiredFields = [
            "maxVisitor",
            "visitDuration",
            "codeExpiration",
            "maxPartySize",
            "automatedExit",
            "maxLocationCapacity",
        ];

        requiredFields.forEach((field) => {
            if (!editData[field]) {
                newErrors[field] = `${capitalizeFirstLetter(field)} is required`;
            } else {
                delete errors[field];
            }
        });

        // ✅ Check if at least one plan is filled
        const plansArray = ["basicPlan", "premiumPlan", "vipPlan"];
        const isAnyPlanFilled = plansArray.some(
            (planKey) => plans[planKey]?.active && plans[planKey]?.price?.trim() && plans[planKey]?.benefits?.[0]?.trim()
        );

        if (!isAnyPlanFilled) {
            newErrors["plans"] = "At least one plan (Basic, Premium, or VIP) must be filled.";
        } else {
            delete newErrors["plans"];
        }

        // ✅ Validate Only Active Plans
        plansArray.forEach((planKey) => {
            const plan = plans[planKey];
            if (!plan?.active) return; // Skip validation if plan is inactive

            // ✅ Allow price "0" for Basic Plan
        if (!plan?.price?.trim()) {
            newErrors[`${planKey}_price`] = "Price is required";
        } else if (
            isNaN(plan?.price) || 
            (Number(plan?.price) <= 0 && planKey !== "basicPlan") // Allow 0 only for Basic Plan
        ) {
            newErrors[`${planKey}_price`] = "Enter a valid price";
        } else {
            delete newErrors[`${planKey}_price`];
        }

        if (!plan?.benefits?.[0]?.trim()) {
            newErrors[`${planKey}_benefit_0`] = "At least one benefit is required.";
        } else {
            delete newErrors[`${planKey}_benefit_0`];
        }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };




    console.log("percentageValue plans", percentageValue, tempValue)
    let imageCloudFront = window?.site?.common?.imageCloudfront
    return (
        <>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content user-management">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* Breadcrumb */}
                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Location management</h4>
                                            <p className="menu-path">
                                                <span>Location management</span> / <b>{add === true ? "Create" : "EDIT"}</b>

                                            </p>
                                        </div>
                                        <div>
                                            <button className="stroke-btn-style" id="back-button" onClick={handleBack}>
                                                <span className="material-symbols-outlined">arrow_back</span>Back
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Form Content */}
                            <div className="row table-data">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-body edit-store">
                                            <ul className="nav nav-tabs nav-tabs-custom" role="tablist" id="tab-navigation">
                                                <li className="nav-item" role="presentation" onClick={() => handleTabSwitch("location")} id="tab-location-info" style={{ cursor: "pointer" }}>
                                                    <a
                                                        className={`nav-link ${locationStatus ? "active" : ""}`}
                                                        role="tab"
                                                        aria-selected={locationStatus}
                                                        id="location-info-tab"
                                                    >
                                                        <span className="material-symbols-outlined">package_2</span>
                                                        <span className="d-none d-sm-block">Location info</span>
                                                    </a>
                                                </li>
                                                <li className="nav-item" role="presentation" onClick={() => handleTabSwitch("preferences")} id="tab-preferences" style={{ cursor: "pointer" }}>
                                                    <a
                                                        className={`nav-link ${preferenceStatus ? "active" : ""}`}
                                                        role="tab"
                                                        aria-selected={preferenceStatus}
                                                        id="preferences-tab"
                                                    >
                                                        <span className="material-symbols-outlined">tune</span>
                                                        <span className="d-none d-sm-block">PREFERENCES</span>
                                                    </a>
                                                </li>
                                                <li className="nav-item" role="presentation" onClick={() => handleTabSwitch("spots")} id="tab-preferences" style={{ cursor: "pointer" }}>
                                                    <a
                                                        className={`nav-link ${spotsStatus ? "active" : ""}`}
                                                        role="tab"
                                                        aria-selected={spotsStatus}
                                                        id="preferences-tab"
                                                    >
                                                        <span className="material-symbols-outlined">explore_nearby</span>
                                                        <span className="d-none d-sm-block">SPOTS</span>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="note" id="store-hidden-message">
                                                                    Your store will remain hidden from visitors until regular hours are set
                                            </div>
                                            <div className="tab-content p-3 text-muted">
                                                {locationStatus &&
                                                    <div className="tab-pane active show" id="home1" role="tabpanel">

                                                        <div className="row location-info">
                                                            {/* <h4 className="form-title" id="location-info-title">LOCATION INFO</h4> */}


                                                            {/* FORMS */}
                                                            <div className="col-md-6 right-section">

                                                                {/* Store Name Input */}
                                                                {/* <div className="mb-3"> */}
                                                                <label className="form_label" htmlFor="location-name" id="location-name-label">LOCATION NAME<span className="required">*</span></label>
                                                                <div className="input-group mb-2 mr-sm-2" id="location-name-group">
                                                                    <div className="input-group-prepend" id="location-name-icon">
                                                                        <div className="input-group-text">
                                                                            <span className="material-symbols-outlined">storefront</span>
                                                                        </div>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                                        id="location-name-input"
                                                                        name="name"
                                                                        value={formData?.name}
                                                                        onChange={handleChange}
                                                                        placeholder="Enter Location Name"

                                                                    />
                                                                    {errors.name && (
                                                                        <div className="invalid-feedback" id="location-name-error">{errors.name}</div>
                                                                    )}
                                                                </div>

                                                                {/* </div> */}

                                                                {/* Category Select */}
                                                                {/* <div className="mb-3"> */}
                                                                <label className="form_label mt-3" htmlFor="category-select" id="category-label">LOCATION CATEGORY<span className="required">*</span></label>
                                                                <div className="input-group mb-2 mr-sm-2" id="category-group">
                                                                    <div className="input-group-prepend" id="category-icon">
                                                                        <div className="input-group-text">
                                                                            <span className="material-symbols-outlined">store</span>
                                                                        </div>
                                                                    </div>
                                                                    <select
                                                                        className={`form-select ${errors.category ? 'is-invalid' : ''}`}
                                                                        id="category-select"
                                                                        name="category"
                                                                        value={formData?.category}
                                                                        onChange={handleChange}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <option value="" id="category-option-default">Select Category</option>
                                                                        {data?.map((item) => {
                                                                            return (
                                                                                <option value={item?.name} id="category-option-retail">{item?.name}</option>
                                                                            )
                                                                        })}


                                                                    </select>
                                                                    {errors.category && (
                                                                        <div className="invalid-feedback" id="category-error">{errors.category}</div>
                                                                    )}
                                                                </div>

                                                                {/* </div> */}

                                                                {/* Phone Input */}
                                                                {/* <div className="mb-3"> */}
                                                                <label className="form_label mt-3" htmlFor="phone-input" id="phone-label">LOCATION PHONE NUMBER<span className="required">*</span></label>
                                                                <div className="input-group mb-2 mr-sm-2" id="phone-group">
                                                                    <div className="input-group-prepend">
                                                                        <div className="input-group-text"><span className="material-symbols-outlined">call</span></div>
                                                                    </div>
                                                                    <select name="idc" className="colorselect capitalize"
                                                                        onChange={handleCountryChange} value={formData?.idc || " USA(+1)"}>
                                                                        <option value="">Select</option>
                                                                        {countries && countries?.length > 0 && countries?.map((task, i) => (
                                                                            <option key={i} value={`${task?.alpha3.trim()}${task?.countrycode.trim()}`}>{task?.alpha3.trim() + task?.countrycode.trim()}</option>
                                                                        ))}
                                                                    </select>
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                                                        id="phone-input"
                                                                        name="phone"
                                                                        value={formData?.phone}
                                                                        onChange={handleChange}
                                                                        placeholder="Enter Phone Number"

                                                                    />
                                                                    {errors.phone && (
                                                                        <div className="invalid-feedback" id="phone-error">{errors.phone}</div>
                                                                    )}
                                                                </div>

                                                                <label className="form_label mt-3" htmlFor="category-select" id="category-label">STATUS<span className="required">*</span></label>
                                                                <div className="input-group mb-2 mr-sm-2" id="category-group">
                                                                    <div className="input-group-prepend" id="category-icon">
                                                                        <div className="input-group-text">
                                                                            <span className="material-symbols-outlined">store</span>
                                                                        </div>
                                                                    </div>
                                                                    <select
                                                                        className={`form-select ${errors.status ? 'is-invalid' : ''}`}
                                                                        id="category-select"
                                                                        name="status"
                                                                        value={formData?.status}
                                                                        onChange={handleChange}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <option value="" id="category-option-default">Select Status</option>
                                                                        <option value="ACTIVE" id="category-option-retail">ACTIVE</option>
                                                                        <option value="INACTIVE" id="category-option-retail">INACTIVE</option>


                                                                    </select>
                                                                    {errors.status && (
                                                                        <div className="invalid-feedback" id="category-error">{errors.status}</div>
                                                                    )}
                                                                </div>
                                                                <label class="form_label mt-3" for="phone-input" id="upload-logo-label">UPLOAD LOCATION LOGO<span style={{ textTransform: "lowercase" }}>(Optional)</span></label>
                                                                <div className="d-flex upload_images mb-3" id="upload-images-section">
                                                                    {formData?.logo?.length > 0 ? (
                                                                        <div className="thumbnail-pic" id="thumbnail-container">
                                                                            <span
                                                                                className="material-symbols-outlined thumbnail-cls-icon"
                                                                                id="remove-logo-btn"
                                                                                onClick={e => handleRemove()}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                close
                                                                            </span>

                                                                            <img
                                                                                src={
                                                                                    formData?.logo?.[0]?.filepath?.startsWith("blob:")
                                                                                        ? formData?.logo[0]?.filepath  // Show blob preview URL
                                                                                        : imageCloudFront + formData?.logo?.[0]?.filepath // Show server URL
                                                                                }
                                                                                id="active-image"
                                                                                alt="Uploaded Logo"
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <div id="logo-upload-container" className="add_block">
                                                                                <input
                                                                                    type="file"
                                                                                    id="logo-upload"
                                                                                    accept="image/jpeg, image/png, image/heic, image/jpg"
                                                                                    className="d-none"
                                                                                    multiple={false}
                                                                                    onChange={handleFileChange}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* <label
                htmlFor="logo-upload"
                className="stroke-button mt-3"
                id="upload-logo-label"
            >
                <span className="material-icons me-2" id="upload-icon">file_upload</span> UPLOAD LOGO
            </label> */}
                                                                                <label
                                                                                    htmlFor="logo-upload"
                                                                                    id="upload-logo-label"
                                                                                    style={{ display: "contents" }}
                                                                                >
                                                                                    <span className="material-symbols-outlined" id="upload-icon">add</span>
                                                                                    <span>ADD</span>
                                                                                </label>
                                                                            </div>

                                                                            <div className="file_requirements" id="file-requirements">
                                                                                <p id="max-file-size">Maximum file size: 5MB</p>
                                                                                <p id="supported-formats">Supported formats: JPG, PNG, HEIC</p>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>



                                                                {/* Store Images */}

                                                                <div className="mb-3" id="store-images-section">
                                                                    <label className="form_label mt-3" id="upload-store-images-label">UPLOAD LOCATION IMAGES</label>
                                                                    {/* <label className="col-form-label store_label" id="upload-store-images-label">Upload Store Images</label> */}
                                                                    <div className="d-flex upload_images mb-3" id="store-upload-container">

                                                                        {storeFiles?.length > 0 && storeFiles?.map((item, index) => (
                                                                            <div key={index} className="thumbnail-pic" id={`uploaded-store-image-${index}`}>
                                                                                <span
                                                                                    className="material-symbols-outlined thumbnail-cls-icon"
                                                                                    id={`delete-store-image-${index}`}
                                                                                    onClick={(e) => deleteclick(item, index)}
                                                                                >
                                                                                    close
                                                                                </span>
                                                                                <img
                                                                                    src={item?.image}
                                                                                    alt={`StoreImage ${index + 1}`}
                                                                                    id={`store-image-preview-${index}`}
                                                                                />
                                                                            </div>
                                                                        ))}

                                                                        {formData?.storeImages?.map((image, index) => (
                                                                            image?.filepath && (
                                                                                <div key={index} className="thumbnail-pic" id={`existing-store-image-${index}`}>
                                                                                    <span
                                                                                        className="material-symbols-outlined thumbnail-cls-icon"
                                                                                        id={`delete-existing-image-${index}`}
                                                                                        onClick={(e) => deleteclick(image, index)}
                                                                                    >
                                                                                        close
                                                                                    </span>
                                                                                    <img
                                                                                        src={imageCloudFront + image?.filepath}
                                                                                        alt={`Store ${index + 1}`}
                                                                                        id={`store-existing-image-preview-${index}`}
                                                                                    />
                                                                                </div>
                                                                            )
                                                                        ))}

                                                                        <div className="add_block" id="add-store-image-section">
                                                                            <input
                                                                                type="file"
                                                                                id="store-file-upload"
                                                                                accept="image/jpeg, image/png, image/heic, image/jpg"
                                                                                className="d-none"
                                                                                multiple={true}
                                                                                onChange={e => handleStoreImageUpload(e)}
                                                                                style={{ display: 'none' }}
                                                                            />
                                                                            {/* <label
            htmlFor="store-file-upload"
            className="stroke-btn fill-btn-style rounded-pill px-3 py-2 mb-2 mb-lg-0 mt-3"
            id="add-store-image-btn"
        >
            Add file
        </label> */}
                                                                            <label
                                                                                htmlFor="store-file-upload"
                                                                                className="Add-Icon"
                                                                                id="add-store-image-btn"
                                                                            >
                                                                                <span class="material-symbols-outlined">add</span>
                                                                                <span>ADD</span>
                                                                            </label>
                                                                        </div>

                                                                        <div className="file_requirements" id="store-file-requirements">
                                                                            <p id="store-max-file-size">Maximum file size: 5MB</p>
                                                                            <p id="store-supported-formats">Supported formats: JPG, PNG, HEIC</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Store Images */}

                                                              
                                                                {/* {locationFlag === true &&
                                                                    <button className="fill-btn save_continue float-none mt-3" style={{ cursor: "pointer" }} onClick={spotClick}>
                                                                        <i className="fas fa-map-marker-alt" style={{ marginRight: "8px" }}></i>
                                                                        Add Spot
                                                                    </button>} */}

                                                            </div>


                                                            {/* Map Section */}
                                                            <div className="col-md-6" id="map-section">
                                                                <label className="form_label" htmlFor="html">LOCATION ADDRESS<span class="required">*</span></label>
                                                                <div className="input-group mb-2 mr-sm-2" id="address-input-group">
                                                                    <div className="input-group-prepend">
                                                                        <div className="input-group-text" id="address-icon">
                                                                            <span className="material-symbols-outlined">location_on</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {errors.address && (
                                                                    <div className="" id="address-error">{errors.address}</div>
                                                                )}
                                                                <div className="map_block" id="map-block">
                                                                    {mapsAPIkey !== false && formData && (
                                                                        <LocationSearch
                                                                            id="location-search"
                                                                            setSelectedPlace={null}
                                                                            setAddressData={(data) => {
                                                                                setAddressData(data);
                                                                                handleAddressChange(data);
                                                                            }}
                                                                            mapVisible={true}
                                                                            formData={mapaddress}
                                                                            mapsAPIkey={mapsAPIkey}
                                                                            style={{ cursor: "pointer" }}
                                                                        />
                                                                    )}


                                                                </div>

                                                                {/* Submit Button */}
                                                                <div>
                                                                    {updateFlagValue == true ?
                                                                        <button
                                                                            onClick={handleSubmit}
                                                                            className="fill-btn save_continue mt-3"
                                                                            id={locationFlag === false ? "save-and-continue-button" : "update-and-continue-button"}
                                                                            style={{ cursor: "pointer" }}

                                                                        //disabled={isSaveDisabled}
                                                                        >
                                                                            {loaderEnable ? (
                                                                                <img
                                                                                    src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                                                                    className="loading-icon"
                                                                                />
                                                                            ) : null}
                                                                            {locationFlag === false ? "Save & Continue" : "Update & Continue"}
                                                                        </button> :
                                                                        <button
                                                                            onClick={handleSubmit}
                                                                            className="fill-btn save_continue mt-3"
                                                                            id={locationFlag === false ? "save-and-continue-button" : "update-and-continue-button"}
                                                                            style={{ cursor: "not-allowed" }}
                                                                            disabled
                                                                        //disabled={isSaveDisabled}
                                                                        >
                                                                            {loaderEnable ? (
                                                                                <img
                                                                                    src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                                                                    className="loading-icon"
                                                                                />
                                                                            ) : null}
                                                                            {locationFlag === false ? "Save & Continue" : "Update & Continue"}
                                                                        </button>}

                                                                    {/* <button
className="fill-btn save_continue mt-4 float-none"
onClick={handleSubmit} {loaderEnable === "updateForm" ? (<img src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"} className="loading-icon" />) : null}
>
Save & Continue
</button> */}
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                }
                                                {preferenceStatus &&
                                                    <div className="" id="profile1" role="tabpanel">
                                                        {/* here */}
                                                        <h4 className="form-title">PREFERENCES</h4>
                                                        {/* <div className="row preferences-tab">

                                                            <div className="col-md-4">
                                                                <div className="store_block">
                                                                    <div className="Range-box-section">
                                                                        <h3 className="Range-title">Max Visitors Per Spot</h3>
                                                                        <div className="d-flex range-section">
                                                                            <span className="mx-2">0</span><input className="range-style mx-2" type="range" name="maxVisitor" min="0" max="10" onChange={preferenceChange} value={editData?.maxVisitor}></input><span className="me-4">10</span>
                                                                            <input className="range-input-style" placeholder="0" type="text" value={editData?.maxVisitor}></input>
                                                                            {errors.maxVisitor && <p className="error">{errors.maxVisitor}</p>}
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="store_block">
                                                                    <div className="Range-box-section">
                                                                        <h3 className="Range-title">Visit Duration Per Spot</h3>
                                                                        <div className="d-flex range-section">
                                                                            <span className="mx-2">0</span><input className="range-style mx-2" type="range" name="visitDuration" min="0" max="10" onChange={preferenceChange} value={editData?.visitDuration}></input><span className="me-4">10min</span>
                                                                            <input className="range-input-style" placeholder="0" type="text" value={editData?.visitDuration}></input>
                                                                            {errors.visitDuration && <p className="error">{errors.visitDuration}</p>}
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="store_block">
                                                                    <div className="Range-box-section">
                                                                        <h3 className="Range-title">Automated Exit Per Spot</h3>
                                                                        <div className="d-flex range-section">
                                                                            <span className="mx-2">0</span><input className="range-style mx-2" type="range" name="automatedExit" min="0" max="600" onChange={preferenceChange} value={editData?.automatedExit}></input><span className="me-4">600</span>
                                                                            <input className="range-input-style" placeholder="0" type="text" value={editData?.automatedExit}></input>
                                                                            {errors.automatedExit && <p className="error">{errors.automatedExit}</p>}
                                                                        </div>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="store_block">
                                                                    <div className="Range-box-section">
                                                                        <h3 className="Range-title">Code Expiration Per Spot</h3>
                                                                        <div className="d-flex range-section">
                                                                            <span className="mx-2">0</span><input className="range-style mx-2" type="range" name="codeExpiration" min="0" max="410" onChange={preferenceChange} value={editData?.codeExpiration}></input><span className="me-4">410</span>
                                                                            <input className="range-input-style" placeholder="0" type="text" value={editData?.codeExpiration}></input>
                                                                            {errors.codeExpiration && <p className="error">{errors.codeExpiration}</p>}
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <div className="store_block">
                                                                    <div className="Range-box-section">
                                                                        <h3 className="Range-title">Max Party Size Per Spot</h3>
                                                                        <div className="d-flex range-section">
                                                                            <span className="mx-2">0</span><input className="range-style mx-2" type="range" name="maxPartySize" min="0" max="25" onChange={preferenceChange} value={editData?.maxPartySize}></input><span className="me-4">25</span>
                                                                            <input className="range-input-style" placeholder="0" type="text" value={editData?.maxPartySize}></input>
                                                                            {errors.maxPartySize && <p className="error">{errors.maxPartySize}</p>}
                                                                        </div>
                                                                       
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="store_block">
                                                                    <div className="Range-box-section">
                                                                        <h3 className="Range-title">Max Location Capacity</h3>
                                                                        <div className="d-flex range-section">
                                                                            <span className="mx-2">0</span><input className="range-style mx-2" type="range" name="maxLocationCapacity" min="0" max="25" onChange={preferenceChange} value={editData?.maxLocationCapacity}></input><span className="me-4">25</span>
                                                                            <input className="range-input-style" placeholder="0" type="text" value={editData?.maxLocationCapacity}></input>
                                                                            {errors.maxLocationCapacity && <p className="error">{errors.maxLocationCapacity}</p>}
                                                                        </div>
                                                                        <p className="range-des">Lorem Ipsum is simply dummy text.</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        <div className="row preferences-tab">
                                                            {[
                                                                { label: "Max Visitors Per Spot", name: "maxVisitor", min: 0, max: 100 },
                                                                { label: "Max Party Size Per Spot", name: "maxPartySize", min: 0, max: 100 },
                                                                { label: "Max Location Capacity", name: "maxLocationCapacity", min: 0, max: 1000 },
                                                                { label: "Visit Duration Per Spot", name: "visitDuration", min: 15, max: 1000, unit: "min" },
                                                                { label: "Automated Exit Per Spot", name: "automatedExit", min: 0, max: 600, unit: "min" },
                                                                { label: "Code Expiration Per Spot", name: "codeExpiration", min: 0, max: 410, unit: "min" },

                                                            ].map(({ label, name, min, max, unit = "" }) => (
                                                                <div className="col-md-4" key={name}>
                                                                    <div className="store_block">
                                                                        <div className="Range-box-section">
                                                                            <h3 className="Range-title">{label}</h3>
                                                                            <div className="d-flex range-section">
                                                                                <span className="mx-2">{min}</span>

                                                                                {/* Range Slider */}
                                                                                <input
                                                                                    className="range-style mx-2"
                                                                                    type="range"
                                                                                    name={name}
                                                                                    min={min}
                                                                                    max={max}
                                                                                    onChange={preferenceChange}
                                                                                    value={editData?.[name] != "" ? editData?.[name] : min} // Default to min if undefined
                                                                                />

                                                                                <span className="me-4">{max}{unit}</span>

                                                                                {/* Text Input for Manual Entry */}
                                                                                <input
                                                                                    className="range-input-style"
                                                                                    type="number"
                                                                                    name={name}
                                                                                    min={min}
                                                                                    max={max}
                                                                                    onChange={preferenceChange}
                                                                                    value={editData?.[name] ?? min} // Default to min if undefined
                                                                                />

                                                                                {/* Error Handling */}

                                                                            </div>
                                                                            {editData?.[name] > max && <p className="error">Given value is greater than max value</p>}
                                                                            {errors?.[name] && <p className="error">{errors[name]}</p>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>



                                                        <div className="nav-tabs mt-2"></div>

                                                        <h4 className="form-title mt-4">PLAN SETTINGS</h4>
                                                        <div className="row preferences-tab">
                                                            {plans && Object.keys(plans || {})?.map((key) => {


                                                                let plan = plans[key]
                                                                console.log("keyvv", key)
                                                                const isSaveDisabled = !plan?.active;
                                                                const showPriceError = errors[`${key}_price`]; // Checks if price has error
                                                                const showBenefitError = plan?.showErrors && plan?.benefits[0]?.trim() === "";
                                                                const minPrice = 0;  // Minimum price value
                                                                const maxPrice = 100;
                                                                return (
                                                                    <div key={plan?.id} className="col-md-4">
                                                                        <div className="store_block plan-page">
                                                                            {/* HEADER */}
                                                                            <div className="d-flex justify-content-between line align-items-center">
                                                                                <div className="d-flex align-items-center">
                                                                                    <h3 className="sm-heading">{plan?.name} Plan</h3>
                                                                                    <h3 className={`${plan?.name?.toLowerCase()}-badge-style`}>
                                                                                        <span className="material-symbols-outlined">local_activity</span>
                                                                                        {plan?.name}
                                                                                    </h3>
                                                                                </div>

                                                                                {/* ACTIVE TOGGLE (Only for Premium & VIP) */}
                                                                                {/* {!plan?.fixed && ( */}
                                                                                <div className="input-field switch-buttons d-flex align-items-center">
                                                                                    <label className="col-form-label p-0 me-2">Active</label>
                                                                                    <label className="switch disable mb-0">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={plan?.active}
                                                                                            onChange={() => toggleActive(plan?.id, key)}
                                                                                        />
                                                                                        <span className="slider round"></span>
                                                                                    </label>
                                                                                </div>
                                                                                {/* )} */}
                                                                            </div>
                                                                            {/* RANGE SLIDER & MANUAL INPUT */}
                                                                            <div className="d-flex align-items-center mt-2">
                                                                                <label className="col-form-label p-0 me-2">Percentage</label>
                                                                                {/* Range Slider */}
                                                                                <input
                                                                                    className="range-style mx-2"
                                                                                    type="range"
                                                                                    name="percentage"
                                                                                    min={minPrice}
                                                                                    max={maxPrice}
                                                                                    step="1"
                                                                                    value={plan?.percentage || minPrice}
                                                                                    // value={editData?.[name] != "" ? editData?.[name] : min}
                                                                                    disabled={!plan?.active}
                                                                                    onChange={(e) => handlePercentageChange(e, plan?.id, key)}
                                                                                />

                                                                                <span className="me-3">{maxPrice}</span>

                                                                                {/* Manual Entry Input */}
                                                                                <input
                                                                                    className="range-input-style"
                                                                                    type="number"
                                                                                    name="percentage"
                                                                                    min={minPrice}
                                                                                    max={maxPrice}
                                                                                    value={plan?.percentage}
                                                                                    disabled={!plan?.active}
                                                                                    onChange={(e) => handlePercentageChange(e, plan?.id, key)}
                                                                                //onBlur={(e) => handlePercentageChange(e, plan?.id, key)}
                                                                                />
                                                                                {errors.percentage && <span className="text-danger">{errors.percentage}</span>}
                                                                            </div>
                                                                            {/* PRICE INPUT */}

                                                                            {/* {!plan?.fixed && ( */}
                                                                            <div className="input-group mb-2 mr-sm-2">
                                                                                <input
                                                                                    className={`form-control ${errors[`${plan?.id}_price`] ? "is-invalid" : ""}`}
                                                                                    placeholder="Enter Price *"
                                                                                    type="text"
                                                                                    value={plan?.price || ""}
                                                                                    disabled={!plan?.active}
                                                                                    onChange={(e) => handlePlansChange(plan?.id, "price", e.target.value)}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
                                                                                            e.preventDefault(); // Prevent entering non-numeric characters
                                                                                        }
                                                                                    }}
                                                                                />

                                                                                {/* {errors[`${plan?.id}_price`] && <small className="text-danger">{errors[`${plan?.id}_price`]}</small>} */}
                                                                            </div>
                                                                            {/* )} */}

                                                                            {showPriceError && <small className="text-danger">{errors[`${key}_price`]}</small>}

                                                                            {/* BENEFITS HEADER */}
                                                                            <div className="d-flex justify-content-between line align-items-center mt-3">
                                                                                <h3 className="sm-heading">What do you get?</h3>
                                                                            </div>

                                                                            {/* BENEFIT FIELDS */}
                                                                            {plan?.benefits?.map((benefit, index) => {
                                                                                const showBenefitFieldError = errors[`${key}_benefit_${index}`]; // Check for individual benefit errors

                                                                                return (
                                                                                    <div className="input-group mb-2 mr-sm-2" key={index}>
                                                                                        <input
                                                                                            className={`form-control ${showBenefitFieldError ? "is-invalid" : ""}`}
                                                                                            placeholder={index === 0 ? "Enter * (Required)" : "Enter"}
                                                                                            type="text"
                                                                                            value={plan?.benefits[index]}
                                                                                            disabled={!plan?.active}
                                                                                            onChange={(e) =>
                                                                                                handlePlansChange(plan?.id, `benefit_${index}`, e.target.value, index)
                                                                                            }

                                                                                        />
                                                                                        {showBenefitFieldError && (
                                                                                            <small className="text-danger">{errors[`${key}_benefit_${index}`]}</small>
                                                                                        )}

                                                                                        {/* Delete Button */}
                                                                                        <div className="input-group-prepend">
                                                                                            <div
                                                                                                className="input-group-text"
                                                                                                onClick={() =>
                                                                                                    handlePlansChange(plan?.id, `benefit_${index}`, "", index, true)
                                                                                                }
                                                                                            >
                                                                                                <span className="material-symbols-outlined">delete</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}

                                                                            {/* SAVE BUTTON */}
                                                                            {/* <div>
                                                                            <button className="fill-btn-style" disabled={isSaveDisabled} onClick={() => handleSave(plan?.id)} style={{ cursor: "pointer" }}>
                                                                                UPDATE
                                                                            </button>
                                                                            </div> */}


                                                                        </div>

                                                                    </div>
                                                                );
                                                            })}
                                                            <div className="col-md-12 text-right mt-4">
                                                                {updateFlagValue == false ?
                                                                    <button
                                                                        className="fill-btn-style"
                                                                        disabled
                                                                        onClick={e => handleSave(e)}
                                                                        style={{ cursor: "not-allowed" }}
                                                                        id="preferences-submit-button"
                                                                    >
                                                                        {loaderEnable ? (
                                                                            <img
                                                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                                className="loading-icon"
                                                                                alt="Loading"
                                                                            />
                                                                        ) : null}
                                                                        UPDATE
                                                                    </button> :
                                                                    <button
                                                                        className="fill-btn-style"
                                                                        // disabled={updateFlagValue}
                                                                        onClick={e => handleSave(e)}
                                                                        style={{ cursor: "pointer" }}
                                                                        id="preferences-submit-button"
                                                                    >
                                                                        {loaderEnable ? (
                                                                            <img
                                                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                                className="loading-icon"
                                                                                alt="Loading"
                                                                            />
                                                                        ) : null}
                                                                        UPDATE
                                                                    </button>}
                                                            </div>
                                                        </div>

                                                    </div>}
                                                {spotsStatus &&
                                                    <div className="" id="profile2" role="tabpanel">
                                                        {/* here */}
                                                        <h4 className="form-title">SPOTS</h4>

                                                        <div className="row spots-tab">
                                                            <button
                                                                className="fill-btn-style"
                                                                // disabled={updateFlagValue}
                                                                onClick={spotClick}
                                                                style={{ cursor: "pointer" }}
                                                                id="spots-submit-button"
                                                            >
                                                                Manage Spots
                                                            </button>
                                                        </div>
                                                    </div>}

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal className="access-denied" show={showDeleteAlert} >

                        <div className="modal-body enquiry-form">
                            <div className="container">
                                <button className="close-btn" onClick={e => handleClose()}><span className="material-icons">close</span></button>
                                {/* <span className="material-icons access-denied-icon">https</span> */}
                                <span className="material-icons access-denied-icon">delete_outline</span>
                                <h3>Delete</h3>
                                <p>Are you sure you want to delete this logo.</p>
                                <div className="popup-footer">
                                    <button
                                        className="fill-btn mt-3"
                                        type="button"
                                        onClick={handleDeleteClick}

                                    >
                                        {deleteLoader ? (
                                            <img
                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                className="loading-icon"
                                                alt="Loading"
                                            />
                                        ) : null}
                                        Yes
                                    </button>


                                </div>
                            </div>
                        </div>

                    </Modal>
                    <Modal className="access-denied" show={deletePopup} >

                        <div className="modal-body enquiry-form">
                            <div className="container">
                                <button className="close-btn" onClick={e => handleClose()}><span className="material-icons">close</span></button>
                                {/* <span className="material-icons access-denied-icon">https</span> */}
                                <span className="material-icons access-denied-icon">delete_outline</span>
                                <h3>Delete</h3>
                                <p>Are you sure you want to delete this image.</p>
                                <div className="popup-footer">
                                    <button
                                        className="fill-btn mt-3"
                                        type="button"
                                        onClick={deletePopupClick}

                                    >
                                        {deleteLoader ? (
                                            <img
                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                className="loading-icon"
                                                alt="Loading"
                                            />
                                        ) : null}
                                        Yes
                                    </button>


                                </div>
                            </div>
                        </div>

                    </Modal>

                    {/* <SweetAlert show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                    >
                    </SweetAlert> */}
                    {/* <SweetAlert show={message}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={locationFlag === false ? "Location created successfully!" : "Location updated successfully!"}
                        onConfirm={e => { { setMessage(false) } }}
                    >
                    </SweetAlert> */}

                    <SweetAlert show={fileSizeError}
                        warning
                        confirmBtnText="ok"
                        confirmBtnBsStyle="danger"
                        title={"File size greater than 5MB"}
                        onConfirm={e => setFileSizeError(false)}
                    >
                    </SweetAlert>

                    <SweetAlert
                        show={showAlert}
                        title={alertConfig.title}
                        type={alertConfig.type}
                        onConfirm={() => setShowAlert(false)}
                    >
                        {alertConfig.message}
                    </SweetAlert>

                    {/* <SweetAlert
                        show={showDeleteAlert}
                        title="Are you sure you want to delete this logo?"
                        showCancel
                        confirmBtnText="OK"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="primary"
                        cancelBtnBsStyle="danger"
                        onConfirm={handleDeleteClick} // Handle delete action
                        onCancel={() => setShowDeleteAlert(false)} // Close alert on cancel
                    /> */}
                    {/* <SweetAlert
                        show={deletePopup}
                        title="Are you sure you want to delete this Image?"
                        showCancel
                        confirmBtnText="OK"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="primary"
                        cancelBtnBsStyle="danger"
                        onConfirm={deletePopupClick} // Handle delete action
                        onCancel={() => setDeletePopup(false)} // Close alert on cancel
                    /> */}

                    <ToastContainer
                        id="toastContainer"
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover={false}
                        theme="light"
                    />

                    {/* Session Popup */}
                    {state?.showSessionPopup && <SessionPopup />}
                    <Footer />

                </div>



            </div>
        </>
    );
};

export default EditStore;
